<template>
  <TitleWrapper
    title="SECTION_ATTENDANCE"
    additional-name="Settings"
    :is-buttons-hidden="true"
    :is-right-bar-button-hidden="true"
  />
  <UITabs v-model="activePage" :tabs-list="tabsList" />
  <div v-if="activePage === FEATURES_TABS.GENERAL">
    <NoRecordFound />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.PERMISSION">
    <FeatureSettingsPermissionsView
      :feature-name="MYQAMPUS_FEATURE_NAMES.STUDENTS_SECTION_ATTENDANCE"
    />
  </div>
  <div v-else-if="activePage === FEATURES_TABS.NOTIFICATION">
    <SectionAttendanceNotification />
  </div>
</template>

<script>
import { MYQAMPUS_FEATURE_NAMES } from '@/src/constants/feature-name-constants'
import NoRecordFound from '@src/components/BaseComponent/NoRecordFound.vue'
import SectionAttendanceNotification from '@views/settings/notifications/attendance/section/SectionAttendanceNotificationView.vue'
import { FEATURES_TABS_LIST, FEATURES_TABS } from '@src/constants/general-constants.js'
import UITabs from '@src/components/UiElements/UITabs.vue'
import TitleWrapper from '@components/TitleWrapper.vue'
import FeatureSettingsPermissionsView from '@/src/router/views/settings/system-settings/FeatureSettingsPermissionsView.vue'

export default {
  name: 'Settings',
  components: {
    UITabs,
    TitleWrapper,
    NoRecordFound,
    SectionAttendanceNotification,
    FeatureSettingsPermissionsView,
  },

  page: {
    title: 'Features Settings',
  },

  data() {
    return {
      FEATURES_TABS,
      MYQAMPUS_FEATURE_NAMES,
      tabsList: FEATURES_TABS_LIST,
      activePage: FEATURES_TABS.GENERAL,
    }
  },
}
</script>
